export const ICON_SIZE = 16

export const MIDDLE_ICON_SIZE = 22
